import axios from 'axios'
import {
  MakeCounterOfferPayload,
  OfferProjectFiltered,
  AdminSaleOfferGroup,
  UserSaleOfferDetail,
  SaleOfferApiPayload,
  SaleOfferGroup,
  UserSaleOffer,
} from 'src/core/models'

export const getAllSaleOfferGroupsAPI = async (): Promise<AdminSaleOfferGroup[]>  => {
  const { data } = await axios.get<AdminSaleOfferGroup[]>('/api/v1/sale_offer_groups/get_all/')
  return data
}

export const getSaleOfferGroupsAPI = async (): Promise<SaleOfferGroup[]>  => {
  const { data } = await axios.get<SaleOfferGroup[]>('/api/v1/sale_offer_groups/')
  return data
}

export const createSaleOfferGroupsAPI = async (payload: { name: string }): Promise<string>  => {
  const { data } = await axios.post('/api/v1/sale_offer_groups/', payload)
  return data
}

export const filterSaleOfferProjectAPI = async (
  value: string | number, filterType: 'name' | 'id'
): Promise<OfferProjectFiltered>  => {

  const url = `/api/v1/sale_offers/filter_project_for_offer/?${filterType}=${value}`
  const { data } = await axios.get<{ data: OfferProjectFiltered }>(url)
  return data.data
}

export const createSaleOfferAPI = async (payload: SaleOfferApiPayload): Promise<string>  => {
  const { data } = await axios.post('/api/v1/sale_offers/', payload)
  return data
}

export const getUserSaleOffersAPI = async (): Promise<UserSaleOffer[]>  => {
  const url = '/api/v1/sale_offers/get_user_sale_offers/'
  const { data } = await axios.get<UserSaleOffer[]>(url)
  return data
}

export const getUserSaleOfferDetailsAPI = async (offerId: number): Promise<UserSaleOfferDetail>  => {
  const url = `/api/v1/sale_offers/${offerId}/get_user_sale_offer_details/`
  const { data } = await axios.get<UserSaleOfferDetail>(url)
  return data
}

export const acceptUserSaleOfferAPI = async (offerId: number): Promise<string>  => {
  const url = `/api/v1/sale_offers/${offerId}/accept_user_offer/`
  const { data } = await axios.patch(url, {})
  return data
}

export const rejectUserSaleOfferAPI = async (offerId: number): Promise<string>  => {
  const url = `/api/v1/sale_offers/${offerId}/reject_user_offer/`
  const { data } = await axios.patch(url, {})
  return data
}

export const makeCounterSaleOfferAPI = async (
  offerId: number, payload: MakeCounterOfferPayload
): Promise<UserSaleOffer>  => {
  const url = `/api/v1/sale_offers/${offerId}/make_counter_offer/`
  const { data } = await axios.patch<{ message: string, data: UserSaleOffer }>(url, payload)
  return data.data
}
